export const DEFAULT_MIDDLEMILE_PRICING_CONFIG = {
    serviceFee: 599, // £5.99
    vatRate: 0.20, // 20%
    basePrice: 8000, // £80.00
    pricePerMile: 250, // £2.50
    pricePerPallet: 1500, // £15.00
    pricePerKg: 5, // £0.05
    minDistance: 10,
    overnightMultiplier: 1.3,
};
export function calculateMiddleMilePricing(input) {
    const config = input.config;
    const distance = Math.max(input.distanceMiles, config.minDistance);
    const pallets = input.palletCount || 0;
    const weight = input.weightKg || 0;
    const basePrice = config.basePrice;
    const distanceCharge = Math.round(distance * config.pricePerMile);
    const palletCharge = pallets * config.pricePerPallet;
    const weightCharge = Math.round(weight * config.pricePerKg);
    let servicePrice = basePrice + distanceCharge + palletCharge + weightCharge;
    if (input.isOvernight) {
        servicePrice = Math.round(servicePrice * config.overnightMultiplier);
    }
    const serviceFee = config.serviceFee ?? 599;
    const vatRate = config.vatRate ?? 0.20;
    const vatAmount = Math.round((servicePrice + serviceFee) * vatRate);
    const customerTotal = servicePrice + serviceFee + vatAmount;
    return {
        basePrice,
        distanceCharge,
        palletCharge,
        weightCharge,
        servicePrice,
        serviceFee,
        vatAmount,
        customerTotal,
        formatted: {
            basePrice: formatPence(basePrice),
            distanceCharge: formatPence(distanceCharge),
            palletCharge: formatPence(palletCharge),
            weightCharge: formatPence(weightCharge),
            servicePrice: formatPence(servicePrice),
            serviceFee: formatPence(serviceFee),
            vatAmount: formatPence(vatAmount),
            customerTotal: formatPence(customerTotal),
        },
    };
}
export function formatPence(pence) {
    return `£${(pence / 100).toFixed(2)}`;
}
//# sourceMappingURL=pricing.js.map